var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hekang"},[_c('div',{staticStyle:{"text-align":"center"}}),_c('div',{staticStyle:{"text-align":"center","height":"calc(100% - 85px)","padding":"30px 0","box-sizing":"border-box"}})])
}]

export { render, staticRenderFns }